export default {
    w100: {
        width: '100%'
    }
}